import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const attempts = [{
  title: 'Cardio Excesivo',
  desc: 'Solo inflama tus articulaciones y eleva aún más el cortisol, empeorando el problema.'
}, {
  title: 'Dietas de Hambre',
  desc: 'Destruyen tu metabolismo y te dejan sin fuerza para rendir en el trabajo.'
}, {
  title: "Suplementos 'Milagro'",
  desc: 'De farmacia son solo cafeína y promesas vacías sin base científica.'
}, {
  title: 'Entrenar como a los 20',
  desc: 'Intentar entrenar como un chico de 20 años solo te lleva a lesiones y a un agotamiento más profundo.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function FailedAttempts() {
  return <section className="py-16 md:py-24 px-6 bg-brand-dark" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-20">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-brand-text uppercase mb-4" data-id="element-21">
            Por qué lo que has intentado{' '}
            <span className="text-brand-red" data-id="element-22">no funcionó</span>
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-23">
          {attempts.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-brand-surface p-6 rounded-xl border border-brand-card flex items-start gap-4" data-id="element-24">
              <XCircle className="w-8 h-8 text-brand-red flex-shrink-0 mt-1" aria-hidden="true" data-id="element-25" />
              <div data-id="element-26">
                <h3 className="font-heading font-bold text-xl text-brand-text uppercase mb-2" data-id="element-27">
                  {item.title}
                </h3>
                <p className="font-body text-brand-muted leading-relaxed" data-id="element-28">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}